<template>
  <el-form label-width="80px" label-position="left" :model="detail">
    <el-form-item label="投标结果">
      <el-radio-group v-model="detail.State">
        <el-radio :label="true">已中标</el-radio>
        <el-radio :label="false">未中标/废标</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="中标价格">
      <el-input v-model="detail.Price" clearable>
        <template slot="suffix">元</template>
      </el-input>
    </el-form-item>
    <el-form-item label="报价文件">
      <uploader :objectId="detail.Id" mode="bidfile" :autoupload="true" listtype="text" accept=".doc,.docx,.rar,.zip" />
    </el-form-item>
    <el-form-item>
      <el-button type="primary" icon="el-icon-position" @click="onSubmit">提交</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  components: {
    uploader: () => import('@/views/system/file/multipleUpload.vue')
  },
  data () {
    return {
      detail: this.row
    }
  },
  props: {
    row: { type: Object },
    callback: { type: Function },
    layerid: { type: String, default: null }
  },
  methods: {
    onSubmit () {
      this.$apis.project.inquiry.complete(this.detail).then(() => {
        typeof this.callback == "function" && this.callback(this.detail)
        this.$message({ message: "操作成功", type: "success" })
        this.$layer.close(this.layerid)
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
